import React from 'react';

import {createNativeStackNavigator} from '@react-navigation/native-stack';
import ShiftClaimScreen from '../screens/ShiftClaimScreen';
import {ShiftClaimScreens} from './types';

const Stack = createNativeStackNavigator();

const ShiftClaimNavigator: React.FC = () => (
  <Stack.Navigator screenOptions={{headerShown: false}}>
    <Stack.Screen
      name={ShiftClaimScreens.ShiftClaimScreen}
      component={ShiftClaimScreen}
    />
  </Stack.Navigator>
);

export default ShiftClaimNavigator;
